import { RoundNameWithStatistics } from "../model/rounds";

/** A round's correction progress as the dashboard table shows it. Shares are percentages of all observations. */
export interface RoundRow {
  roundName: string;
  observations: number;
  /** Sample set plus ambiguous, the observations someone has looked at. */
  corrected: number;
  correctedShare: number;
  sampleSet: number;
  sampleSetShare: number;
  ambiguous: number;
  ambiguousShare: number;
  lowAccuracy: number;
  lowAccuracyShare: number;
}

export const share = (part: number, total: number) => (total > 0 ? (part / total) * 100 : 0);

export const toRoundRow = (round: RoundNameWithStatistics): RoundRow => {
  const observations = round.corrected + round.ambiguous + round.notCorrected;
  const corrected = round.corrected + round.ambiguous;
  return {
    roundName: round.roundName,
    observations,
    corrected,
    correctedShare: share(corrected, observations),
    sampleSet: round.corrected,
    sampleSetShare: share(round.corrected, observations),
    ambiguous: round.ambiguous,
    ambiguousShare: share(round.ambiguous, observations),
    lowAccuracy: round.lowAccuracy,
    lowAccuracyShare: share(round.lowAccuracy, observations),
  };
};

export interface RoundsSummary {
  rounds: number;
  observations: number;
  corrected: number;
  correctedShare: number;
}

export const summarizeRounds = (rounds: RoundNameWithStatistics[]): RoundsSummary => {
  const rows = rounds.map(toRoundRow);
  const observations = rows.reduce((sum, r) => sum + r.observations, 0);
  const corrected = rows.reduce((sum, r) => sum + r.corrected, 0);
  return { rounds: rounds.length, observations, corrected, correctedShare: share(corrected, observations) };
};
